import Vue, { PropType, VNode, VNodeChildren } from 'vue';
import PlayerOverlayManagerStyle from './style.module.scss';
import { CreateElement } from 'vue/types/umd';
import { InPlayerOverlayManifest } from './implementation/manifest';
import { AlignmentKey, getOverlayToDisplay, toRenderNodeOptions } from './implementation/manifestController';

const styleMap: Record<AlignmentKey, string> = {
  alignTop: 'mb-auto',
  alignRight: 'ml-auto',
  alignBottom: 'mt-auto',
  alignLeft: 'mr-auto',
  fillHorizontal: 'w-100',
  fillVertical: 'h-100',
};

const wrapContent = (h: CreateElement, children: VNodeChildren): VNode => h('div', {
  staticClass: 'h-100 w-100 stick-all-corners d-flex',
  class: PlayerOverlayManagerStyle.wrapper,
}, children);

export default Vue.extend({
  name: 'InPlayerOverlaysManager',
  functional: true,
  props: {
    manifests: {
      type: Array as PropType<InPlayerOverlayManifest[]>,
      default: (): InPlayerOverlayManifest[] => [],
    },
  },
  render(h, { props }): VNode[] {
    const manifestItems = getOverlayToDisplay(props.manifests)
      .map(toRenderNodeOptions)
      .map(({ component, alignment }) => (
        h(
          'div',
          {
            class: [
              PlayerOverlayManagerStyle.item,
              ...[...alignment].map(key => styleMap[key]),
            ],
            attrs: {
              'data-ui-section': 'in-player-overlay',
            },
          },
          [
            h(component),
          ],
        )
      ))
    ;
    return manifestItems.map(item => wrapContent(h, [item]));
  },
});
